export default __webpack_public_path__ + "static/media/sqr_img_3.e8ef0ec3.svg";